import React from 'react';

const ProjectTwrEsmCategoriesIndex = React.lazy(() => import("./index"))
const NewProjectTwrEsmCategories = React.lazy(() => import("./new"))
const EditProjectTwrEsmCategories = React.lazy(() => import("./edit"))

export default[
	{path:'/project/twr/esm_categories/:id/edit',component: EditProjectTwrEsmCategories,name:'Edit ProjectTwrEsmCategory'},
	{path:'/project/twr/esm_categories/new',component: NewProjectTwrEsmCategories,name:'New ProjectTwrEsmCategory'},  
	{path:'/project/twr/esm_categories',component: ProjectTwrEsmCategoriesIndex,name:'ProjectTwrEsmCategories'}, 
]

// import ProjectTwrEsmCategoriesRoutes from "modules/project/twr/esm_categories/web/routes"
// routes = _.concat(routes,ProjectTwrEsmCategoriesRoutes)
